import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { CONTACT } from "../../lib/data";

export const FloatingCTA = () => (
  <motion.div initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }}
    transition={{ delay: 1.5, duration: 0.6 }}
    className="fixed right-4 bottom-4 z-40 flex flex-col gap-3" data-testid="floating-cta">
    <a href={`https://wa.me/${CONTACT.whatsappLink}`} target="_blank" rel="noreferrer"
      data-testid="floating-whatsapp-btn" aria-label="WhatsApp Us"
      className="group h-14 w-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-lg shadow-black/20 hover:scale-110 transition-transform">
      <MessageCircle />
    </a>
    <a href={`tel:${CONTACT.phoneLink}`} data-testid="floating-call-btn" aria-label="Call Us"
      className="h-14 w-14 rounded-full bg-primary-blue text-white grid place-items-center shadow-lg shadow-black/20 hover:scale-110 transition-transform">
      <Phone />
    </a>
  </motion.div>
);
